module.exports = __webpack_public_path__ + "img/u42.f1151aac.png";